module.exports = __webpack_public_path__ + "img/avatar6.5a2fc0b1.png";